import AdminClient from '../client/AdminClient';
import _ from "lodash";
import {mapIds} from "../../../helpers/utils";

class RiaContactService {
    static async notes(contactId, session) {
        return AdminClient.get(`/v1/admin/ria_contacts/${contactId}/notes`, session);
    }

    static async regenerateAiBio(contactId, session) {
        return AdminClient.put(`/v1/admin/ria_contacts/${contactId}/regenerate_ai_bio`, session);
    }

    static async validateEmailDomain(contactId, session, email) {
        return AdminClient.put(`/v1/admin/ria_contacts/${contactId}/validate_email_domain`, session, {email:email});
    }

    static async warnings(crdId, session, params) {
        return AdminClient.get(`/v1/admin/ria_contacts/${crdId}/warnings`, session, params);
    }

    static async updateWarning(warningId, session, warning) {
        return AdminClient.put(`/v1/admin/ria_contacts/${warningId}/update_warning`, session, warning);
    }

    static async findMatch(params, session) {
        return AdminClient.get(`/v1/admin/ria_contacts/find_match`, session, params);
    }
}
export default RiaContactService;